import { useEffect } from 'react';

export function useKeyboardNav(
  onNext: () => void,
  onPrev: () => void,
  onSkip: () => void,
) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') onNext();
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') onPrev();
      else if (e.key === 'Escape') onSkip();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onNext, onPrev, onSkip]);
}
